import React, { useContext } from 'react';
import { Card, Box } from '@mui/material';
import PPLLC from 'Components/Doc/ppLLC/index';
import { AppContext } from 'Context';
import { V2SettingsShell } from '../../_shared/V2SettingsShell';

export const PrivacySettingsV2 = () => {
  const { langText } = useContext(AppContext);
  const privacyText = langText?.settings?.privacy;
  return (
    <V2SettingsShell title={privacyText?.title || 'Privacy'}>
      <Card sx={{ p: { xs: 2.5, md: 4 } }}>
        <Box sx={{ '& *': { color: 'text.primary' } }}>
          <PPLLC />
        </Box>
      </Card>
    </V2SettingsShell>
  );
};
